<div *ngIf="isLoading" class="loader-overlay">
  <img class="loader" src="assets/loader-myselogerpro.gif">
</div>

<ng-content></ng-content>
